/* Kimaty catalogue interactions. No cart actions or product prices are used. */
(() => {
  const mobileMenus = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function setDetailsOpen(details, open) {
    const controller = mobileMenus.get(details);
    if (controller) controller(open); else details.open = open;
  }
  function initMobile(details) {
    if (mobileMenus.has(details)) return;
    const summary = details.querySelector(':scope > summary');
    const panel = details.querySelector(':scope > nav, :scope > .kd-mobile-children');
    if (!summary || !panel) return;
    let animation;
    let expanded = details.open;
    const setOpen = (open) => {
      expanded = open;
      const start = details.open ? panel.getBoundingClientRect().height : 0;
      const startStyle = getComputedStyle(panel);
      const startPaddingTop = details.open ? startStyle.paddingTop : '0px';
      const startPaddingBottom = details.open ? startStyle.paddingBottom : '0px';
      if (animation) { animation.cancel(); animation = null; }
      details.open = true;
      summary.setAttribute('aria-expanded', String(open));
      if (details.matches('.kd-mobile-menu')) summary.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      const end = open ? panel.getBoundingClientRect().height : 0;
      const endStyle = getComputedStyle(panel);
      const endPaddingTop = open ? endStyle.paddingTop : '0px';
      const endPaddingBottom = open ? endStyle.paddingBottom : '0px';
      const finish = () => {
        details.open = open;
        panel.style.removeProperty('overflow');
        if (animation) { animation.cancel(); animation = null; }
      };
      if (reducedMotion.matches || !panel.animate || start === end) { finish(); return; }
      panel.style.overflow = 'hidden';
      animation = panel.animate(
        [{ height: `${start}px`, paddingTop: startPaddingTop, paddingBottom: startPaddingBottom, opacity: open ? 0.5 : 1 }, { height: `${end}px`, paddingTop: endPaddingTop, paddingBottom: endPaddingBottom, opacity: open ? 1 : 0 }],
        { duration: 280, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'both' }
      );
      animation.onfinish = finish;
    };
    mobileMenus.set(details, setOpen);
    summary.setAttribute('aria-expanded', String(expanded));
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      setOpen(!expanded);
    });
  }
  function updateHeaderHeight() {
    const header = document.getElementById('header-group');
    if (header) document.documentElement.style.setProperty('--kd-sticky-header-height', `${header.getBoundingClientRect().height}px`);
  }
  const headerObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(updateHeaderHeight) : null;
  function setDropdownOpen(dropdown, open) {
    dropdown.toggleAttribute('open', open);
    dropdown.toggleAttribute('data-kd-dismissed', !open);
    dropdown.querySelector('.kd-nav-trigger')?.setAttribute('aria-expanded', String(open));
    dropdown.dispatchEvent(new Event('kd:dropdown-toggle'));
  }
  function init(root = document) {
    root.querySelectorAll('.kd-mobile-menu, .kd-mobile-branch').forEach(initMobile);
    const header = document.getElementById('header-group');
    if (header) headerObserver?.observe(header);
    updateHeaderHeight();
    root.querySelectorAll('.kd-nav-dropdown').forEach((dropdown) => {
      if (dropdown.dataset.kdTopHoverReady) return;
      dropdown.dataset.kdTopHoverReady = 'true';
      const trigger = dropdown.querySelector('.kd-nav-trigger');
      let closeTimer;
      const cancelClose = () => window.clearTimeout(closeTimer);
      const open = () => {
        cancelClose();
        document.querySelectorAll('.kd-nav-dropdown[open]').forEach((other) => {
          if (other !== dropdown) setDropdownOpen(other, false);
        });
        setDropdownOpen(dropdown, true);
      };
      const closeSoon = () => {
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (!dropdown.contains(document.activeElement)) setDropdownOpen(dropdown, false);
        }, 180);
      };
      dropdown.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'touch') open();
      });
      dropdown.addEventListener('pointerleave', closeSoon);
      dropdown.addEventListener('focusin', (event) => {
        cancelClose();
        if (event.target !== trigger) open();
      });
      dropdown.addEventListener('focusout', (event) => {
        if (!dropdown.contains(event.relatedTarget)) closeSoon();
      });
      trigger.addEventListener('click', () => {
        cancelClose();
        if (dropdown.hasAttribute('open')) setDropdownOpen(dropdown, false); else open();
      });
      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          open();
          dropdown.querySelector('.kd-nav-panel a')?.focus();
        }
      });
    });
    root.querySelectorAll('.kd-nav-body').forEach((body) => {
      const groups = [...body.querySelectorAll('[data-kd-hover-group]')];
      if (!groups.length || body.dataset.kdHoverReady) return;
      body.dataset.kdHoverReady = 'true';
      body.classList.add('kd-nav-interactive');
      const controllers = groups.map((group) => {
        const button = group.querySelector('.kd-nav-expand');
        const shapes = group.querySelector('.kd-nav-shapes');
        const setOpen = (open) => {
          shapes.hidden = !open;
          button.setAttribute('aria-expanded', String(open));
          body.classList.toggle('kd-nav-expanded', groups.some((item) => !item.querySelector('.kd-nav-shapes').hidden));
        };
        button.hidden = false;
        setOpen(false);
        group.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'touch') setOpen(true);
        });
        group.addEventListener('pointerleave', () => {
          if (!group.contains(document.activeElement)) setOpen(false);
        });
        group.addEventListener('focusin', (event) => {
          if (event.target !== button) setOpen(true);
        });
        group.addEventListener('focusout', (event) => {
          if (!group.contains(event.relatedTarget)) setOpen(false);
        });
        button.addEventListener('click', () => setOpen(shapes.hidden));
        group.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !shapes.hidden) {
            event.preventDefault();
            event.stopPropagation();
            setOpen(false);
            button.focus();
          }
        });
        return setOpen;
      });
      // Start collapsed even when multiple category groups exist.
      body.classList.remove('kd-nav-expanded');
      body.closest('.kd-nav-dropdown')?.addEventListener('kd:dropdown-toggle', (event) => {
        if (!event.currentTarget.hasAttribute('open')) controllers.forEach((setOpen) => setOpen(false));
      });
    });
    root.querySelectorAll('[data-kd-product]').forEach((product) => {
      if (product.dataset.kdReady) return;
      product.dataset.kdReady = 'true';
      const slides = [...product.querySelectorAll('[data-kd-media]')];
      const thumbs = [...product.querySelectorAll('[data-kd-thumb]')];
      const showMedia = (id) => {
        if (!slides.some((slide) => slide.dataset.kdMedia === id)) return;
        slides.forEach((slide) => {
          const active = slide.dataset.kdMedia === id;
          slide.hidden = !active;
          if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
          if (!active) slide.querySelectorAll('iframe').forEach((frame) => {
            const src = frame.getAttribute('src');
            if (src) frame.setAttribute('src', src);
          });
        });
        thumbs.forEach((thumb) => thumb.setAttribute('aria-pressed', String(thumb.dataset.kdThumb === id)));
      };
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.kdThumb)));
      const select = product.querySelector('[data-kd-variant]');
      const whatsapp = product.querySelector('[data-kd-enquire]');
      const email = product.querySelector('[data-kd-email]');
      function updateEnquiry() {
        if (!whatsapp) return;
        const option = select?.selectedOptions[0];
        const sku = option?.dataset.sku || product.querySelector('[data-kd-default-sku]')?.value || '';
        const variantTitle = option?.dataset.title || '';
        const url = new URL(whatsapp.dataset.url, window.location.origin);
        if (option) url.searchParams.set('variant', option.value);
        const message = `Hello Kimaty Diamonds, I would like to enquire about ${whatsapp.dataset.title}${sku ? ` (reference: ${sku})` : ''}.${variantTitle ? ` Option: ${variantTitle}.` : ''} ${url.href}`;
        whatsapp.href = `https://wa.me/${whatsapp.dataset.phone}?text=${encodeURIComponent(message)}`;
        if (email) email.href = `mailto:${email.dataset.email}?subject=${encodeURIComponent(`Enquiry: ${whatsapp.dataset.title}`)}&body=${encodeURIComponent(message)}`;
        const reference = product.querySelector('[data-kd-reference]');
        if (reference && sku) reference.textContent = sku;
        if (option?.dataset.media) showMedia(option.dataset.media);
      }
      select?.addEventListener('change', () => {
        updateEnquiry();
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url);
      });
      updateEnquiry();
    });
    root.querySelectorAll('.kd-hero').forEach((hero) => {
      if (hero.dataset.kdReady) return;
      hero.dataset.kdReady = 'true';
      const video = hero.querySelector('video');
      const toggle = hero.querySelector('[data-kd-video-toggle]');
      if (!video || !toggle) return;
      toggle.hidden = false;
      const refresh = () => {
        toggle.textContent = video.paused ? 'Play video' : 'Pause video';
        toggle.setAttribute('aria-label', video.paused ? 'Play background video' : 'Pause background video');
      };
      video.addEventListener('play', refresh);
      video.addEventListener('pause', refresh);
      toggle.addEventListener('click', () => {
        if (video.paused) video.play().catch(refresh); else video.pause();
      });
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && !navigator.connection?.saveData) video.play().catch(refresh);
      refresh();
    });
    root.querySelectorAll('[data-kd-sort]').forEach((sort) => {
      if (sort.dataset.kdReady) return;
      sort.dataset.kdReady = 'true';
      sort.addEventListener('change', () => sort.form.requestSubmit());
    });
    root.querySelectorAll('.kd-mobile-menu, .kd-filter').forEach((details) => {
      if (details.dataset.kdReady) return;
      details.dataset.kdReady = 'true';
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        document.querySelectorAll('.kd-mobile-menu[open], .kd-filter[open]').forEach((other) => { if (other !== details) setDetailsOpen(other, false); });
        document.querySelectorAll('.kd-nav-dropdown[open]').forEach((dropdown) => setDropdownOpen(dropdown, false));
      });
    });
  }
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.kd-nav-dropdown[open]').forEach((dropdown) => { setDropdownOpen(dropdown, false); dropdown.querySelector('.kd-nav-trigger')?.focus(); });
    document.querySelectorAll('.kd-mobile-menu[open], .kd-filter[open]').forEach((details) => { setDetailsOpen(details, false); details.querySelector('summary')?.focus(); });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.kd-nav-dropdown[open]').forEach((dropdown) => { if (!dropdown.contains(event.target)) setDropdownOpen(dropdown, false); });
    document.querySelectorAll('.kd-mobile-menu[open], .kd-filter[open]').forEach((details) => { if (!details.contains(event.target)) setDetailsOpen(details, false); });
  });
  window.addEventListener('resize', updateHeaderHeight);
  window.matchMedia('(min-width: 900px)').addEventListener('change', (event) => {
    if (event.matches) document.querySelectorAll('.kd-mobile-menu[open]').forEach((details) => setDetailsOpen(details, false));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
